module.exports = __webpack_public_path__ + "img/arr.a44f8193.png";